import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className"];
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { StylesModalVariables } from './Modal';
import { jsx as ___EmotionJSX } from "@emotion/react";

const ModalBody = _ref => {
  let {
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: /*#__PURE__*/_css({
      padding: StylesModalVariables(theme).padding
    }, process.env.NODE_ENV === "production" ? "" : ";label:ModalBody;"),
    className: clsx(`CK__ModalBody ${theme.settings.classes.trim}`, className)
  }, rest));
};

export default ModalBody;